"use client";

import { c as _c } from "react/compiler-runtime";
import { isNativeToken } from "../../../anyspend/index.js";
import { useAccountWallet, useAuthStore } from "../../../global-account/react/index.js";
import { formatTokenAmount } from "../../../shared/utils/number.js";
import { getERC20Balances, getNativeTokenBalance } from "../../../shared/utils/thirdweb-insights.js";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
export function useTokenBalance(t0) {
  const $ = _c(26);
  const {
    token,
    address
  } = t0;
  const isAuthenticated = useAuthStore(_temp);
  const account = useAccountWallet();
  const effectiveAddress = address || account?.address;
  let t1;
  let t2;
  if ($[0] !== effectiveAddress || $[1] !== token.address || $[2] !== token.chainId) {
    t1 = ["tokenBalance", effectiveAddress, token.chainId, token.address];
    t2 = async () => {
      if (!effectiveAddress) {
        return {
          formatted: "0",
          raw: null
        };
      }
      if (isNativeToken(token.address)) {
        const nativeToken = await getNativeTokenBalance(effectiveAddress, token.chainId);
        if (nativeToken && nativeToken.balance) {
          const rawBalance = nativeToken.balance;
          return {
            formatted: formatTokenAmount(BigInt(rawBalance), Number(nativeToken.decimals || 18)),
            raw: BigInt(rawBalance)
          };
        }
        return {
          formatted: "0",
          raw: null
        };
      }
      const response = await getERC20Balances(effectiveAddress, {
        chainIds: [token.chainId],
        includeSpam: false
      });
      const tokenBalance = response.data?.find(t => t.token_address === token.address);
      if (tokenBalance?.balance) {
        return {
          formatted: formatTokenAmount(BigInt(tokenBalance.balance), Number(tokenBalance.decimals || 18)),
          raw: BigInt(tokenBalance.balance)
        };
      }
      return {
        formatted: "0",
        raw: null
      };
    };
    $[0] = effectiveAddress;
    $[1] = token.address;
    $[2] = token.chainId;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  const t3 = isAuthenticated && !!effectiveAddress;
  let t4;
  if ($[5] !== t1 || $[6] !== t2 || $[7] !== t3) {
    t4 = {
      queryKey: t1,
      queryFn: t2,
      enabled: t3,
      staleTime: 30000,
      gcTime: 300000,
      retry: 2,
      structuralSharing: false
    };
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const {
    data: tokenBalance_0,
    isLoading,
    isFetching,
    refetch
  } = useQuery(t4);
  let t5;
  if ($[9] !== effectiveAddress || $[10] !== isAuthenticated || $[11] !== refetch) {
    t5 = () => {
      if (isAuthenticated && effectiveAddress) {
        refetch();
      }
    };
    $[9] = effectiveAddress;
    $[10] = isAuthenticated;
    $[11] = refetch;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== effectiveAddress || $[14] !== isAuthenticated || $[15] !== refetch || $[16] !== token.address || $[17] !== token.chainId || $[18] !== token.symbol) {
    t6 = [isAuthenticated, effectiveAddress, token.address, token.chainId, token.symbol, refetch];
    $[13] = effectiveAddress;
    $[14] = isAuthenticated;
    $[15] = refetch;
    $[16] = token.address;
    $[17] = token.chainId;
    $[18] = token.symbol;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  useEffect(t5, t6);
  const isActuallyLoading = !isAuthenticated || !effectiveAddress || isLoading || isFetching && !tokenBalance_0;
  let t7;
  if ($[20] !== tokenBalance_0?.raw) {
    t7 = tokenBalance_0?.raw || BigInt(0);
    $[20] = tokenBalance_0?.raw;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  const t8 = tokenBalance_0?.formatted || "0";
  let t9;
  if ($[22] !== isActuallyLoading || $[23] !== t7 || $[24] !== t8) {
    t9 = {
      rawBalance: t7,
      formattedBalance: t8,
      isLoading: isActuallyLoading
    };
    $[22] = isActuallyLoading;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  return t9;
}
function _temp(state) {
  return state.isAuthenticated;
}